import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

const ptMonths: Record<string, number> = {
  'jan': 0, 'fev': 1, 'mar': 2, 'abr': 3, 'mai': 4, 'jun': 5,
  'jul': 6, 'ago': 7, 'set': 8, 'out': 9, 'nov': 10, 'dez': 11
};

export function parsePressReleaseDate(dateStr: string): Date {
  const [day, monthStr, year] = dateStr.split(' ');
  const month = ptMonths[monthStr.toLowerCase()] || 0;
  return new Date(parseInt(year), month, parseInt(day));
}

const ptMonthAbbr = ['Jan', 'Fev', 'Mar', 'Abr', 'Mai', 'Jun', 'Jul', 'Ago', 'Set', 'Out', 'Nov', 'Dez'];
const esMonthAbbr = ['Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun', 'Jul', 'Ago', 'Sep', 'Oct', 'Nov', 'Dic'];

// Datas vindas do Supabase/CMS chegam em ISO (YYYY-MM-DD, do <input type="date"> do admin).
// As do fallback estatico ja chegam prontas como "24 Abr 2025". Esta funcao normaliza
// as duas fontes para o mesmo formato "dia Mes ano" no idioma ativo, para nao misturar
// ISO cru com o formato legado na mesma tela.
export function formatPressReleaseDate(dateStr: string, language: 'pt' | 'es' | 'en'): string {
  if (!dateStr) return '';
  const isoMatch = /^(\d{4})-(\d{2})-(\d{2})/.exec(dateStr);
  if (!isoMatch) return dateStr;
  const [, year, month, day] = isoMatch;
  const months = language === 'es' ? esMonthAbbr : ptMonthAbbr;
  const monthLabel = months[parseInt(month, 10) - 1] || month;
  return `${parseInt(day, 10)} ${monthLabel} ${year}`;
}
